import {
  AUTH_SIGNUP_URL,
  PATH_AFTER_LOGIN,
  useAuthContext,
} from '@aibees/shared/auth';
import { memo } from 'react';
import { Navigate } from 'react-router-dom';

export const RedirectToSignup = memo(() => {
  const { authenticated } = useAuthContext();
  if (authenticated) return <Navigate to={PATH_AFTER_LOGIN} replace />;
  window.location.replace(AUTH_SIGNUP_URL);
  return null;
});

RedirectToSignup.displayName = 'RedirectToSignup';
